import React, {Component, PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as _ from 'lodash';

import {modifyPageLayoutComponents} from './../../PageLayout';
import template from './Features.rt';
import contentHeaderTemplate from './ContentHeader.rt';
import headerComponent from './Header';
import footerTemplate from './Footer.rt';

import * as Actions from './Actions';
import {isFeatureFilterMarkedForDeletion} from "./Reducer";

const mapStateToProps = (state) => {
  const features = state.filtersAssignToFeatures;
  const groupFeatures = (features.groupFeatures && features.groupFeatures.toJS()) || [];
  _.forEach(groupFeatures, feature => {
    _.forEach(feature.filters, filter => {
      filter.markedForDeletion = isFeatureFilterMarkedForDeletion(features, feature.id, filter.filterValueId);
    })
  })
  const {selectedFeaturesGroups, currentFilterValues} = features;
  const lcGroupsTerm = features.groupsTerm.toLowerCase();
  const groupHeaders = _.filter(features.groupHeaders.toJS(),
      gh => features.groupsTerm ? gh.name.toLowerCase().includes(lcGroupsTerm) : true);
  _.forEach(groupHeaders, gh => gh.isSelected = selectedFeaturesGroups[gh.id]);
  return {
    groupHeaders,
    selectedGroupHeader: features.selectedGroupHeader,
    groupFeatures,
    totalPages: features.totalPages,
    page: features.page,
    term: features.term,
    itemsPerPage: features.itemsPerPage,
    areFeaturesFiltersCollapsed: features.areFeaturesFiltersCollapsed,
    featuresFiltersToBeDeletedCount: features.featuresFiltersToBeDeleted.size,
    groupsTerm: features.groupsTerm,
    selectedFeaturesGroups: _.cloneDeep(selectedFeaturesGroups),
    currentFilterValues: _.cloneDeep(currentFilterValues),
    colorFilters: {
      items: features.colorFilters,
      checked: []
    },
    allOtherFilters: {
      items: features.allOtherFilters,
      checked: []
    }
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFeaturesGroupHeaders: () => dispatch(Actions.getFeaturesGroupHeaders()),
    getFeaturesFromGroup: (group, term = '', page = 0) => dispatch(Actions.getFeaturesFromGroup(group, term, page)),
    markFeatureChecked: (feature, check) => dispatch(Actions.markFeatureChecked(feature, check)),
    markAllFeaturesChecked: check => dispatch(Actions.markAllFeaturesChecked(check)),
    showAssignPopup: show => dispatch(Actions.showAssignPopup(show)),
    back: () => dispatch(Actions.backToFiltersManagement()),
    collapseFeaturesFilters: collapse => dispatch(Actions.collapseFeaturesFilters(collapse)),
    markFeatureFilterForDeletion: (featureId, filterValueId, mark) => dispatch(Actions.markFeatureFilterForDeletion(featureId, filterValueId, mark)),
    handleCancelClick: () => dispatch(Actions.cancelFeatureFilterDeletion()),
    handleSaveClick: () => dispatch(Actions.deleteFeaturesFilters()),
    setGroupsTerm: groupsTerm => dispatch(Actions.setGroupsTerm(groupsTerm)),
    selectFeaturesGroup: (group, select) => dispatch(Actions.selectFeaturesGroup(group, select)),
    fetchFeaturesFromCurrentState: () => dispatch(Actions.fetchFeaturesFromCurrentState()),
    setPage: page => dispatch(Actions.setPage(page)),
    setTerm: term => dispatch(Actions.setTerm(term)),
    setItemsPerPage: itemsPerPage => dispatch(Actions.setItemsPerPage(itemsPerPage)),
    handleColorFilterClick: (item, type) => dispatch(Actions.handleColorFilterClick(item, type)),
    handleNonColorFilterClick: (item, type) => dispatch(Actions.handleNonColorFilterClick(item, type))
  }
};

class FeaturesComponent extends Component {
  static propTypes = {
    itemsPerPage: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    term: PropTypes.string.isRequired,
    selectedFeaturesGroups: PropTypes.object.isRequired,
    currentFilterValues: PropTypes.array.isRequired,

    setPage: PropTypes.func.isRequired,
    setItemsPerPage: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  componentDidMount() {
    this.props.getFeaturesGroupHeaders();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.selectedFeaturesGroups, prevProps.selectedFeaturesGroups)
      || this.props.page !== prevProps.page
      || this.props.term !== prevProps.term
      || this.props.itemsPerPage !== prevProps.itemsPerPage
      || !_.isEqual(this.props.currentFilterValues, prevProps.currentFilterValues)) {
      this.props.fetchFeaturesFromCurrentState();
    }
  }

  handlePaginate = page => {
    // this.props.getFeaturesFromGroup(this.props.selectedGroupHeader, this.props.term, page - 1);
    this.props.setPage(page - 1);
  }

  render = template
}

const connector = connect(mapStateToProps, mapDispatchToProps);

class Footer extends PureComponent {
  render = footerTemplate
}

export const FeaturesLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(headerComponent),
  contentHeader: connector(contentHeaderTemplate),
  content: connector(FeaturesComponent),
  pageFooter: connector(Footer)
});


